export default __webpack_public_path__ + "static/media/a1-4-9.4322ecd4.jpg";